export const MERCHANT_ONBOARDING_STAGES = {
  verifyEmail: "verify_email",
  businessDetails: "business_details",
  completed: "completed",
} as const;

export type MerchantOnboardingStage =
  (typeof MERCHANT_ONBOARDING_STAGES)[keyof typeof MERCHANT_ONBOARDING_STAGES];

const merchantOnboardingStages = new Set<string>(Object.values(MERCHANT_ONBOARDING_STAGES));

export const isMerchantOnboardingStage = (value: string | null): value is MerchantOnboardingStage =>
  value !== null && merchantOnboardingStages.has(value);
